export type ThemeType = "dark" | "light" | "none";

export const getTheme = (): ThemeType => {
    /*深色模式*/
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return "dark";
    }
    /*浅色模式*/
    if (window.matchMedia('(prefers-color-scheme: light)').matches) {
        return "light";
    }
    return "none";
}